import { useState, useRef, useCallback } from 'react';
import { X } from 'lucide-react';

/**
 * DraggableModal - Modal that can be dragged by its header.
 */
export default function DraggableModal({ title, onClose, children, maxWidth = 'max-w-5xl' }) {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const dragging = useRef(false);

  const onMouseDown = useCallback((e) => {
    if (e.target.closest('button')) return;
    const startX = e.clientX - pos.x;
    const startY = e.clientY - pos.y;

    const onMouseMove = (e) => {
      dragging.current = true;
      setPos({ x: e.clientX - startX, y: e.clientY - startY });
    };

    const onMouseUp = () => {
      dragging.current = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }, [pos]);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div
        className={`bg-white rounded-xl shadow-xl w-full ${maxWidth}`}
        style={{
          transform: `translate(${pos.x}px, ${pos.y}px)`,
          height: '85vh',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div
          className="flex items-center justify-between px-6 py-3 border-b bg-gray-50 rounded-t-xl cursor-move select-none flex-shrink-0"
          onMouseDown={onMouseDown}
        >
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-lg transition-colors">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div style={{ flex: 1, overflow: 'hidden' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
